module.exports = __webpack_public_path__ + "static/media/study_space.3ac4cec2.png";